import {
  getVipRechargeList,
  getVipRechargeCount,
  addVipRecharge,
  searchVip,
  getVipRechargeCost
} from "@/service/resManagement/vipRecharge";

export default {
  name: "vipGroupRecord",
  data() {
    return {
      filters: {
        keyword: "",
        type: -1,
        dateRange: [],
        startDate: "",
        endDate: ""
      },
      list: {
        query: {
          unitId: Number(sessionStorage.getItem("unitId")),
          pageIndex: 1,
          pageSize: 10,
          keyword: "",
          type: -1,
          startDate: "",
          endDate: ""
        },
        total: 0,
        results: []
      },
      recharge: {
        visible: false,
        submitting: false,
        searching: false,
        keyword: "",
        selectedVip: null,
        amount: undefined,
        hours: undefined,
        subject: 2,
        remark: ""
      },
      availableVips: [],
      rechargeCost: null,
      driverSchools: JSON.parse(sessionStorage.getItem("driverSchool") || "[]"),
      columns: [
        {
          title: "序号",
          width: 70,
          align: "center",
          scopedSlots: { customRender: "SerialNumber" }
        },
        { title: "关联VIP", dataIndex: "vipName", width: 100 },
        { title: "手机号码", dataIndex: "vipPhone", width: 130 },
        { title: "驾校", dataIndex: "shortName", width: 130 },
        {
          title: "支付金额",
          dataIndex: "amount",
          width: 100,
          scopedSlots: { customRender: "amount" }
        },
        { title: "对应学时", dataIndex: "hours", width: 100 },
        {
          title: "类型",
          dataIndex: "type",
          width: 90,
          scopedSlots: { customRender: "recordType" }
        },
        {
          title: "科目",
          dataIndex: "subject",
          width: 90,
          scopedSlots: { customRender: "subject" }
        },
        {
          title: "业务单号",
          dataIndex: "businessNo",
          width: 170,
          scopedSlots: { customRender: "businessNo" }
        },
        { title: "操作人", dataIndex: "operatorId", width: 130 },
        { title: "操作时间", dataIndex: "createTime", width: 175 },
        { title: "备注", dataIndex: "remark", width: 160 }
      ]
    };
  },
  computed: {
    pagination() {
      return {
        showQuickJumper: true,
        showSizeChanger: true,
        current: this.list.query.pageIndex,
        pageSize: this.list.query.pageSize,
        total: this.list.total,
        showTotal: total => `共${total}条`,
        pageSizeOptions: ["10", "50", "100"]
      };
    },
    matchingVips() {
      return this.availableVips;
    },
    showVipResults() {
      return !!this.recharge.keyword.trim() && !this.recharge.selectedVip;
    },
    rechargeUnitPrice() {
      if (!this.rechargeCost) {
        return 0;
      }
      const discountedPrice = Number(this.rechargeCost.price) -
        Number(this.rechargeCost.vipPrice || 0) -
        Number(this.rechargeCost.groupPrice || 0);
      return discountedPrice > 0 ? discountedPrice * 2 : 0;
    },
    rechargeAmountStep() {
      const priceInCents = Math.round(this.rechargeUnitPrice);
      if (!(priceInCents > 0)) {
        return 0.01;
      }
      let divisorLeft = priceInCents;
      let divisorRight = 4;
      while (divisorRight) {
        const remainder = divisorLeft % divisorRight;
        divisorLeft = divisorRight;
        divisorRight = remainder;
      }
      return priceInCents / divisorLeft / 100;
    },
    calculatedRechargeHours() {
      const amount = Number(this.recharge.amount);
      if (!(amount > 0) || !(this.rechargeUnitPrice > 0)) {
        return "";
      }
      return (amount * 100 / this.rechargeUnitPrice).toFixed(2);
    },
    calculatedRechargeAmount() {
      const hours = Number(this.recharge.hours);
      if (!(hours > 0) || !(this.rechargeUnitPrice > 0)) {
        return "";
      }
      return (hours * this.rechargeUnitPrice / 100).toFixed(2);
    }
  },
  methods: {
    formatRecordType(type) {
      return Number(type) === 1 ? "充值" : "核销";
    },
    formatSubject(subject) {
      return Number(subject) === 2 ? "科目二" : "科目三";
    },
    getSchoolName(shortId) {
      const school = this.driverSchools.find(item => Number(item.shortId) === Number(shortId));
      return school ? school.shortName : `驾校ID：${shortId}`;
    },
    handleDateChange(date, dateString) {
      this.filters.dateRange = date;
      this.filters.startDate = dateString[0] || "";
      this.filters.endDate = dateString[1] || "";
    },
    queryGroupRecords(queryBy) {
      if (queryBy !== "pagination") {
        this.list.query.pageIndex = 1;
      }
      Object.assign(this.list.query, {
        keyword: this.filters.keyword.trim(),
        type: Number(this.filters.type),
        startDate: this.filters.startDate,
        endDate: this.filters.endDate
      });
      this.loadGroupRecords();
    },
    loadGroupRecords() {
      const countQuery = {
        unitId: this.list.query.unitId,
        keyword: this.list.query.keyword,
        type: this.list.query.type,
        startDate: this.list.query.startDate,
        endDate: this.list.query.endDate
      };
      getVipRechargeCount(countQuery).then(res => {
        this.list.total = res.data ? Number(res.data.rowCount) : 0;
        if (!this.list.total) {
          this.list.results = [];
          return;
        }
        getVipRechargeList(this.list.query).then(listRes => {
          this.list.results = Array.isArray(listRes.data) ? listRes.data : [];
        });
      });
    },
    handleTableChange(pagination) {
      this.list.query.pageIndex = pagination.current;
      this.list.query.pageSize = pagination.pageSize;
      this.loadGroupRecords();
    },
    openRechargeModal() {
      this.recharge.visible = true;
      this.recharge.keyword = "";
      this.recharge.selectedVip = null;
      this.recharge.amount = undefined;
      this.recharge.hours = undefined;
      this.rechargeCost = null;
      this.recharge.subject = 2;
      this.recharge.remark = "";
      this.availableVips = [];
    },
    closeRechargeModal() {
      this.recharge.visible = false;
      this.recharge.submitting = false;
      this.recharge.searching = false;
    },
    handleVipKeywordChange() {
      if (this.recharge.selectedVip) {
        this.recharge.selectedVip = null;
      }
      const keyword = this.recharge.keyword.trim();
      if (!keyword) {
        this.availableVips = [];
        return;
      }
      this.recharge.searching = true;
      searchVip({
        unitId: this.list.query.unitId,
        keyword
      }).then(res => {
        if (keyword === this.recharge.keyword.trim()) {
          const data = res.data;
          this.availableVips = Array.isArray(data) ? data : data ? [data] : [];
        }
        this.recharge.searching = false;
      }).catch(() => {
        this.availableVips = [];
        this.recharge.searching = false;
      });
    },
    selectVip(item) {
      this.recharge.selectedVip = item;
      this.recharge.keyword = `${item.name} / ${item.phone}`;
      this.availableVips = [];
      this.loadRechargeCost();
    },
    handleSubjectChange() {
      this.loadRechargeCost();
    },
    loadRechargeCost() {
      const vip = this.recharge.selectedVip;
      this.rechargeCost = null;
      this.syncRechargeHours();
      if (!vip || !vip.vehType) {
        return;
      }
      const params = {
        unitId: this.list.query.unitId,
        subject: Number(this.recharge.subject),
        vehType: vip.vehType
      };
      getVipRechargeCost(params).then(res => {
        if (this.recharge.selectedVip === vip &&
          Number(this.recharge.subject) === params.subject) {
          const cost = res && res.price !== undefined ? res : res && res.data;
          this.rechargeCost = cost || null;
          this.syncRechargeHours();
        }
      }).catch(() => {
        if (this.recharge.selectedVip === vip) {
          this.rechargeCost = null;
          this.syncRechargeHours();
        }
      });
    },
    syncRechargeHours() {
      if (!this.isRechargeAmountQuarterHour(this.recharge.amount)) {
        this.recharge.hours = undefined;
        return;
      }
      this.recharge.hours = this.calculatedRechargeHours || undefined;
    },
    syncRechargeAmount() {
      this.recharge.amount = this.calculatedRechargeAmount || undefined;
    },
    isQuarterHour(value) {
      const hours = Number(value);
      return hours > 0 && Math.abs(hours * 4 - Math.round(hours * 4)) < 0.000001;
    },
    isRechargeAmountQuarterHour(value) {
      const amount = Number(value);
      const amountInCents = Math.round(amount * 100);
      const priceInCents = Math.round(this.rechargeUnitPrice);
      return amount > 0 && priceInCents > 0 &&
        Math.abs(amount * 100 - amountInCents) < 0.000001 &&
        amountInCents * 4 % priceInCents === 0;
    },
    handleRechargeAmountChange(value) {
      if (value === undefined || value === null || value === "") {
        this.recharge.hours = undefined;
        return;
      }
      if (!this.isRechargeAmountQuarterHour(value)) {
        this.recharge.amount = undefined;
        this.recharge.hours = undefined;
        this.$message.warning("充值金额必须是当前单价下对应0.25学时的整数倍");
        return;
      }
      this.syncRechargeHours();
    },
    handleRechargeHoursChange(value) {
      if (value === undefined || value === null || value === "") {
        this.recharge.amount = undefined;
        return;
      }
      if (!this.isQuarterHour(value)) {
        this.recharge.hours = undefined;
        this.recharge.amount = undefined;
        this.$message.warning("充值学时必须是0.25的整数倍");
        return;
      }
      this.syncRechargeAmount();
    },
    confirmRecharge() {
      if (!this.recharge.selectedVip) {
        this.$message.warning("请先选择关联VIP");
        return;
      }
      if (!(Number(this.recharge.amount) > 0)) {
        this.$message.warning("请输入有效的充值金额");
        return;
      }
      if (!(this.rechargeUnitPrice > 0)) {
        this.$message.warning("未找到对应的价格配置，请先配置训练费用");
        return;
      }
      if (!this.isRechargeAmountQuarterHour(this.recharge.amount)) {
        this.$message.warning("充值金额必须是当前单价下对应0.25学时的整数倍");
        return;
      }
      if (!(Number(this.recharge.hours) > 0)) {
        this.$message.warning("请输入有效的充值学时数");
        return;
      }
      if (!this.isQuarterHour(this.recharge.hours)) {
        this.$message.warning("充值学时必须是0.25的整数倍");
        return;
      }
      if (Math.abs(Number(this.recharge.hours) - Number(this.calculatedRechargeHours)) > 0.01) {
        this.$message.warning(`充值学时与计算结果不一致，应为 ${this.calculatedRechargeHours} 学时`);
        return;
      }

      const vip = this.recharge.selectedVip;
      const params = {
        unitId: this.list.query.unitId,
        vipPhone: vip.phone,
        vipName: vip.name,
        shortId: Number(vip.shortId),
        amount: Number(Number(this.recharge.amount).toFixed(2)),
        hours: Number(Number(this.recharge.hours).toFixed(2)),
        type: 1,
        subject: Number(this.recharge.subject),
        vehType: vip.vehType,
        operatorId: String(sessionStorage.getItem("userId") || ""),
        remark: this.recharge.remark.trim()
      };
      this.recharge.submitting = true;
      addVipRecharge(params).then(res => {
        if (res.result === 0) {
          this.$message.success("团购充值成功");
          this.recharge.visible = false;
          this.queryGroupRecords();
        } else {
          this.$message.error(res.message || "团购充值失败");
        }
        this.recharge.submitting = false;
      }).catch(() => {
        this.recharge.submitting = false;
      });
    },
    exportRecords() {
      const query = {
        ...this.list.query,
        pageIndex: 1,
        pageSize: this.list.total || this.list.query.pageSize
      };
      getVipRechargeList(query).then(res => {
        const records = Array.isArray(res.data) ? res.data : [];
        const typeName = this.list.query.type === -1 ? "全部" :
          this.formatRecordType(this.list.query.type);
        const dateName = this.list.query.startDate || this.list.query.endDate ?
          `${this.list.query.startDate || "不限"} 至 ${this.list.query.endDate || "不限"}` : "全部";
        const condition = [
          `关键词：${this.list.query.keyword || "全部"}`,
          `类型：${typeName}`,
          `操作时间：${dateName}`,
          ...Array(this.columns.length - 3).fill(" ")
        ];
        const excelData = [[
          "序号", "关联VIP", "手机号码", "驾校", "支付金额", "对应学时",
          "类型", "科目", "业务单号", "操作人", "操作时间", "备注"
        ]];
        records.forEach((item, index) => {
          excelData.push([
            index + 1,
            item.vipName,
            item.vipPhone,
            item.shortName,
            item.amount,
            item.hours,
            this.formatRecordType(item.type),
            this.formatSubject(item.subject),
            item.businessNo || "-",
            item.operatorId,
            item.createTime,
            item.remark || ""
          ]);
        });
        this.$refs.export.getExport(condition, ["VIP团购充值"], excelData);
      });
    }
  },
  mounted() {
    this.queryGroupRecords();
  }
};










